export var getKindProp = function getKindProp(item, defaultValue) {
  return typeof item === 'object' && item.kind ? item.kind : defaultValue;
};
//# sourceMappingURL=getKindProp.js.map
